<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_cards'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2">
              <div class="row">
                <b-form-group class="col-md-2" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Class">
                  <v-select
                    :options="schoolclasses.filter((c) => c.level == 1)"
                    @input="FilterExams"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-1" label="Exam">
                  <v-select
                    :options="exams"
                    placeholder="Select Exam"
                    v-model="exam"
                    @input="FetchStudents"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Student">
                  <v-select
                    readonly="true"
                    :options="students"
                    placeholder="Select Student"
                    v-model="student"
                    :reduce="(students) => students.student.student_id"
                  >
                    <template slot="option" slot-scope="option">
                      <div>
                        {{ option.student.first_name }}
                        {{ option.student.last_name }} {{ option.class.name }}
                        {{ option.stream.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div>
                        {{ option.student.first_name }}
                        {{ option.student.last_name }} {{ option.class.name }}
                        {{ option.stream.name }}
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter
                  </b-button>
                </div>
              </div>
            </div>

            <div v-if="exammarks.length > 0">
              <div class="text-center">
                <router-link
                  :to="{
                    path: '/printalevelreportcards',
                    query: {
                      term: schoolterm.id,
                      termname: schoolterm.name,
                      year: year,
                      exam: exam.id,
                      class: schoolclass.id,
                      classname: schoolclass.name,
                      student_id: student,
                    },
                  }"
                  type="button"
                  class="btn-sm btn btn-primary"
                >
                  <i class="mdi mdi-printer"></i> Print
                </router-link>
              </div>

              <div class="card">
                <div
                  class="card-body"
                  style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
                >
                  <div class="d-flex justify-content-start align-items-start">
                    <div class="d-flex justify-content-start">
                      <span v-if="userData.logo != 0"
                        ><img :src="getLogo(userData.logo)" height="80"/><br
                      /></span>
                      <span v-else
                        ><img src="@/assets/images/logo.png" height="80"/></span
                      ><br />
                    </div>

                    <div class="text-start  school-info">
                      <strong class="text-uppercase" style="font-size:22px">{{
                        userData.school
                      }}</strong
                      ><br />
                      <span style="font-size:17px" class="text-uppercase">
                        {{ userData.location }}</span
                      ><br />
                      <span style="font-size:17px"
                        >{{ userData.email }} | {{ userData.contact }}</span
                      ><br />
                      MOTTO :
                      <span style="font-size:15px" class="text-uppercase">
                        {{ userData.motto }}</span
                      >
                    </div>
                  </div>

                  <div class="lines"></div>
                  <br />
                  <div style="text-align: center;">
                    <span
                      style="color: black;font-size:24px;"
                      class="text-uppercase text-decoration-underline"
                    >
                      <b
                        >{{ schoolterm.name }} {{ exam.name }} REPORT -
                        {{ year }}</b
                      > </span
                    ><br /><br />
                  </div>

                  <div class="d-flex justify-content-between">
                    <div
                      class="text-start text-uppercase"
                      style="font-size:17px;"
                    >
                      NAME :
                      <strong
                        >{{ exammarks[0].student.first_name }}
                        {{ exammarks[0].student.last_name }}</strong
                      >
                      <br />
                      STUDENT ID :
                      <strong>{{ exammarks[0].student.student_id }}</strong>
                      <br />
                    </div>

                    <div
                      class="text-end text-uppercase"
                      style="font-size:17px;"
                    >
                      CLASS :
                      <strong
                        >{{ schoolclass.name }}
                        {{ exammarks[0].stream }}</strong
                      ><br />
                      COMBINATION :
                      <strong>{{ exammarks[0].combination }}</strong
                      ><br />
                    </div>

                    <div>
                      <img
                        :src="getFiles(exammarks[0].student.student_photo)"
                        height="80"
                      />
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-10 mx-auto">
                      <table class="table table-sm">
                        <tr class="text-uppercase" style="font-size:15px;">
                          <th>Subjects</th>
                          <th>Papers</th>
                          <th>Marks<br />(100%)</th>
                          <th>Paper Grade</th>
                          <th>Subject Grade</th>
                          <th>Comment</th>
                        </tr>
                        <tr
                          v-for="x in exammarks[0].subjects"
                          :key="x.subject.id"
                        >
                          <td>{{ x.subject.name }}</td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                              >{{ detail.paper.name }}<br
                            /></span>
                          </td>
                          <td style="text-align:center;">
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                              style="text-align: center;"
                              >{{ detail.mark }}<br
                            /></span>
                          </td>
                          <td style="text-align:center;">
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                              style="text-align: center;"
                              >{{ convertGrade(detail.grade) }}<br
                            /></span>
                          </td>
                          <td style="text-align:center;">
                            <span style="font-size:medium;">{{
                              calculateSubjectGrade(x)
                            }}</span>
                          </td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                              >{{ detail.remark }}<br
                            /></span>
                          </td>
                        </tr>
                        <tr style="text-align:center;">
                          <td colspan="6">
                            <span style="font-size:16px;"
                              >TOTAL POINTS :
                              <b style="font-size:larger;">
                                {{ calculateTotalPoints(exammarks[0]) }}
                              </b></span
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-10 mx-auto">
                    <div>
                      <h5 style="text-align:start;">Grading scheme</h5>
                      <table class="table table-sm" style="text-align:center;">
                        <tr>
                          <td>85 - 100</td>
                          <td>80 - 84</td>
                          <td>75 - 79</td>
                          <td>70 - 74</td>
                          <td>65 - 69</td>
                          <td>60 - 64</td>
                          <td>50 - 59</td>
                          <td>40 - 49</td>
                          <td>0 - 39</td>
                        </tr>
                        <tr>
                          <td>D1</td>
                          <td>D2</td>
                          <td>C3</td>
                          <td>C4</td>
                          <td>C5</td>
                          <td>C6</td>
                          <td>P7</td>
                          <td>P8</td>
                          <td>F9</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between mt-2">
                    <div>
                      <h5 class="text-uppercase">
                        <strong>Class Teacher</strong>
                      </h5>
                      <br />
                      <span
                        >Comment:
                        <span class="text-uppercase"
                          ><strong>{{
                            getComment(
                              calculateTotalPoints(exammarks[0]),
                              comment_groups,
                              1,
                            )
                          }}</strong></span
                        ></span
                      ><br />
                      <span class="signature-line">
                        Signature :
                        <span v-if="getSignatureForStatus(comment_groups, 1)">
                          <img
                            :src="getSignatureForStatus(comment_groups, 1)"
                            height="30"
                            alt="Class Teacher Signature"
                          />
                        </span>
                        <span v-else
                          >................................................................................................</span
                        >
                      </span>
                    </div>
                    <div>
                      <h5 class="text-uppercase">
                        <strong>Head Teacher</strong>
                      </h5>
                      <br />
                      <span
                        >Comment:
                        <span class="text-uppercase"
                          ><strong>{{
                            getComment(
                              calculateTotalPoints(exammarks[0]),
                              comment_groups,
                              2,
                            )
                          }}</strong></span
                        ></span
                      ><br />
                      <span class="signature-line">
                        Signature :
                        <span v-if="getSignatureForStatus(comment_groups, 2)">
                          <img
                            :src="getSignatureForStatus(comment_groups, 2)"
                            height="30"
                            alt="Head Teacher Signature"
                          />
                        </span>
                        <span v-else
                          >..................................................................................................</span
                        >
                      </span>
                    </div>
                  </div>
                </div>

                <br />
                <div class="d-flex justify-content-between">
                  <span
                    >SchoolPay Code :
                    <strong class="text-uppercase">
                      {{ exammarks[0].student.school_pay_code }}</strong
                    ></span
                  >
                  <span
                    >Next Term Begins on :
                    <strong class="text-uppercase">{{
                      date(userData.next_term)
                    }}</strong></span
                  >
                  <span
                    >Date of Issue: <strong>{{ currentDate }}</strong></span
                  >
                </div>
                <br /><br />
                <center>
                  <qr-code
                    :text="exammarks[0].student.student_id"
                    :size="100"
                    error-level="L"
                  ></qr-code>
                </center>
              </div>
              <div class="watermark">
                <span v-if="userData.logo != 0"
                  ><img :src="getLogo(userData.logo)" height="250"/><br
                /></span>
                <span v-else
                  ><img src="@/assets/images/logo.png" height="250"/></span
                ><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "A'Level Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "A'Level Report Cards",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "A'Level Report Cards", active: true },
      ],
      id: "",
      schoolsubjects: [],
      exam_subjects: [],
      student_photo: "",
      schoolsubject: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      exams: [],
      students: [],
      year: new Date().getFullYear(),
      marks: [],
      exammarks: { subjects: [] },
      filterby: "1",
      student: "",
      student_id: "",
      currentDate: this.formatDate(new Date()),
      comment_groups: [],
      isLoading: false,
    };
  },
  computed: {
    ...schooltermComputed,
    ...schoolclassComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.isBusy = false;
  },
  methods: {
    ...schooltermMethods,
    ...schoolclassMethods,

    getTeacherInitials(subject) {
      return (
        subject?.teacher?.[0]
          ?.split(" ")
          .map((n) => n[0])
          .join(".") || ""
      );
    },

    getLogo(name) {
      return name ? `${axios.defaults.baseURL.slice(0, -3)}logos/${name}` : "";
    },

    getFiles(name) {
      return name
        ? `${axios.defaults.baseURL.slice(0, -3)}students/${name}`
        : "";
    },

    async FetchStudents() {
      try {
        const url = `/findstudents/${this.schoolclass.id},${this.schoolterm.id},${this.year}`;
        const response = await axios.get(url);
        this.students = response.data.students || [];
      } catch (error) {
        this.students = [];
      }
    },

    async FilterExams() {
      let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },

    FilterData() {
      let formData = new FormData();
      formData.append("term", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("class", this.schoolclass.id);
      formData.append("exam", this.exam.id);
      formData.append("student_id", this.student);

      let url = "/alevelreportmarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.alevelmarks;
      });

      axios
        .get(`/comment-alevel-group/${this.schoolclass.id}`)
        .then((response) => {
          if (response.status == 200) {
            this.comment_groups = response.data.alevelcomments;
          }
        });
    },

    async FilterDataa() {
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append("term", this.schoolterm.id);
        formData.append("year", this.year);
        formData.append("class", this.schoolclass.id);
        formData.append("exam", this.exam.id);
        formData.append("student_id", this.student);

        const [report, comments] = await Promise.all([
          axios.post("/alevelreportmarks", formData),
          axios.get(`/comment-alevel-group/${this.schoolclass.id}`),
        ]);

        this.exammarks = report.data.alevelmarks;
        this.comment_groups = comments.data.alevelcomments || [];
      } catch (error) {
        this.exammarks = { subjects: [] };
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(date) {
      return date?.toLocaleDateString("en-GB") || "";
    },

    date(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date)) return "";

      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const suffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };

      return `${suffix(day)} ${month} ${year}`;
    },

    getComment(aggregate, comment_groups, status) {
      for (let group of comment_groups) {
        const start = parseInt(group.start_agg);
        const end = parseInt(group.end_agg);
        if (group.status == status && aggregate >= start && aggregate <= end) {
          return group.comment;
        }
      }
      return " .............................................................................................. ";
    },

    getSignatureForStatus(comment_groups, status) {
      if (
        !comment_groups ||
        !Array.isArray(comment_groups) ||
        comment_groups.length === 0
      ) {
        return null;
      }
      const group = comment_groups.find(
        (group) => group.status === status && group.signature,
      );

      if (group && group.signature) {
        let url = axios.defaults.baseURL;
        let imagelink = url.slice(0, -3) + "signatures/" + group.signature;
        return imagelink;
      }
      return null;
    },

    calculateSubjectGrade(subject) {
      const grades = subject.details.map((d) => d.grade);
      //Subsidiary
      if (subject.subject.stat === 2) {
        return grades.some((g) => g >= 7) ? "0" : "1";
      }
      //Majors
      const paperCount = grades.length;

      if (paperCount === 2) {
        if (grades.every((g) => g <= 2)) return "A";
        if (grades.every((g) => g <= 3)) return "B";
        if (grades.every((g) => g <= 4)) return "C";
        if (grades.every((g) => g <= 5)) return "D";
        if (
          grades.every((g) => g <= 6) ||
          (grades.reduce((a, b) => a + b) <= 12 && grades.some((g) => g >= 7))
        )
          return "E";
        if (
          grades.reduce((a, b) => a + b) <= 16 ||
          (grades.some((g) => g <= 6) && grades.some((g) => g === 9))
        )
          return "O";
        return "F";
      } else if (paperCount === 3) {
        if (
          Math.max(...grades) <= 3 &&
          grades.filter((g) => g <= 2).length >= 2
        )
          return "A";
        if (Math.max(...grades) <= 4) return "B";
        if (Math.max(...grades) <= 5) return "C";
        if (Math.max(...grades) <= 6) return "D";
        if (grades.some((g) => g === 7) && grades.every((g) => g <= 7))
          return "E";
        if (
          grades.every((g) => g === 7) ||
          grades.every((g) => g === 8) ||
          (grades.filter((g) => g === 9).length === 1 &&
            grades.filter((g) => g <= 8).length === 2)
        )
          return "O";
        return "F";
      } else if (paperCount === 4) {
        if (
          Math.max(...grades) <= 3 &&
          grades.filter((g) => g <= 2).length >= 3
        )
          return "A";
        if (Math.max(...grades) <= 4) return "B";
        if (Math.max(...grades) <= 5) return "C";
        if (Math.max(...grades) <= 6) return "D";
        if (grades.some((g) => g === 7) && grades.every((g) => g <= 7))
          return "E";
        if (
          grades.every((g) => g === 7) ||
          grades.every((g) => g === 8) ||
          (grades.filter((g) => g === 9).length === 1 &&
            grades.filter((g) => g <= 8).length === 3) ||
          (grades.filter((g) => g === 9).length === 2 &&
            grades.filter((g) => g <= 7).length === 2)
        )
          return "O";
        return "F";
      }

      return "F";
    },

    calculateSubjectPoints(subject) {
      const grade = this.calculateSubjectGrade(subject);
      // principal subjects
      if (subject.subject.stat === 1) {
        switch (grade) {
          case "A":
            return 6;
          case "B":
            return 5;
          case "C":
            return 4;
          case "D":
            return 3;
          case "E":
            return 2;
          case "O":
            return 1;
          case "F":
            return 0;
          default:
            return 0;
        }
      }
      // subsidiary subjects
      else if (subject.subject.stat === 2) {
        const allPass = subject.details.every((detail) => detail.grade <= 6);
        return allPass ? 1 : 0;
      }
      return 0;
    },

    calculateTotalPoints(student) {
      let totalPoints = 0;

      if (student.subjects && student.subjects.length > 0) {
        student.subjects.forEach((subject) => {
          totalPoints += this.calculateSubjectPoints(subject);
        });
      }
      return totalPoints;
    },
    convertGrade(grade) {
      const g = parseInt(grade) || 0;

      if (g == 1) return "D1";
      if (g == 2) return "D2";
      if (g == 3) return "C3";
      if (g == 4) return "C4";
      if (g == 5) return "C5";
      if (g == 6) return "C6";
      if (g == 7) return "P7";
      if (g == 8) return "P8";
      return "F9";
    },
  },
};
</script>

<style scoped>
.watermark {
  position: absolute; /* Ensure it's placed over other content */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Center the element */
  opacity: 0.15; /* Adjust opacity as needed */
  pointer-events: none; /* Prevent the watermark from interfering with user interactions */
  z-index: 1000; /* Ensure it's on top of other content */
}

.watermark img {
  max-width: 100%; /* Optional: ensures the logo doesn't stretch */
}

table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}

.signature-line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.font-weight-bold {
  font-weight: bold;
}

.text-uppercase {
  text-transform: uppercase;
}

.bg-light {
  background-color: #f8f9fa;
}

.card {
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-evenly {
  justify-content: space-evenly;
}

.mt-3 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.lines {
  border-bottom: 4px solid black;
  position: relative;
  margin-top: 10px;
}

.lines::after {
  content: "";
  display: block;
  border-bottom: 3px solid orangered;
  margin-top: 2px;
}
.school-info {
  margin-left: 15px;
  line-height: 1.3;
}
</style>
